import { Center, HStack, Skeleton, VStack } from "native-base";
import React from "react";
import { Dimensions, Platform, StyleSheet } from "react-native";
import * as CONSTANTS from "../../../assets/consts/index";
const SCREEN_WIDTH = Dimensions.get("screen").width;
const IS_MOBILE = Platform.OS === "android" || Platform.OS === "ios";
const DeviceSkeleton = (props: any) => {
  const { isKioskMode } = props;
  return (
    <VStack
      style={[
        { flexWrap: "wrap" },
        IS_MOBILE
          ? isKioskMode
            ? { width: (SCREEN_WIDTH - 65) / 6 }
            : { width: (SCREEN_WIDTH - 65) / 2 }
          : styles.wrapperWeb,
      ]}
      borderWidth="1"
      space={3}
      p="10px"
      rounded="lg"
      _dark={{
        borderColor: "coolGray.500",
      }}
      _light={{
        borderColor: "coolGray.200",
      }}
    >
      <Skeleton size="5" rounded="full" />
      <Center w="100%">
        <Skeleton h="3" w="60%" rounded="full" mb="10px" />
        <Skeleton
          borderWidth={1}
          borderColor="coolGray.100"
          size="60px"
          marginY="10px"
          rounded="full"
        />
      </Center>
      <HStack w="100%" flex={1} justifyContent="space-between">
        <Skeleton h="4" w="48%" rounded="full" />
        <Skeleton h="4" w="48%" rounded="full" />
      </HStack>
    </VStack>
  );
};
const styles = StyleSheet.create({
  wrapperWeb: {
    width:
      (Math.min(SCREEN_WIDTH, CONSTANTS.WEB_MAX_WIDTH) -
        (SCREEN_WIDTH < CONSTANTS.WEB_MAX_WIDTH ? 60 : 300)) /
      2,
  },
});
export default DeviceSkeleton;
